import L from 'leaflet';

const DropLocationIcon = new L.Icon({
    iconUrl: require('../../../assets/drop_location.svg'),
    iconAnchor: null,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(30, 36.5),
    className: 'leaflet-icon'
});

export { DropLocationIcon }